import { Component, OnInit } from '@angular/core';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '../../../../core/services/auth/auth.service';

interface SettingMenu {
  key: string;
  name: string;
  detail: string;
  expectedRole?: string[];
}

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrl: './setting.component.css'
})
export class SettingComponent implements OnInit {

  faGear = faGear;

  private allMenus: SettingMenu[] = [
    { key: 'channel', name: 'ร้านค้า', detail: 'ตั้งค่าช่องทางการสั่งซื้อ' },
    { key: 'campaign', name: 'แคมเปญ', detail: 'ตั้งค่าแคมเปญ' },
    { key: 'permission', name: 'สิทธิ์การใช้งาน', detail: 'ตั้งค่าสิทธิ์การเข้าใช้งาน', expectedRole: ['admin'] },
    { key: 'user-platform', name: 'ช่องทางตามผู้ใช้', detail: 'กำหนด platform ที่ผู้ใช้แต่ละคนเข้าถึงได้', expectedRole: ['admin'] },
    { key: 'web-config', name: 'ค่าระบบ', detail: 'ปรับค่า config ของระบบ (% บวกทุน, index ราคา)', expectedRole: ['admin'] }
  ];

  menus: SettingMenu[] = [];
  menuSelected: SettingMenu;

  constructor(
    private authService: AuthService
  ) {
    this.menus = this.allMenus.filter(m => this.canAccess(m));
    this.menuSelected = this.menus[0];
  }

  async ngOnInit(): Promise<void> {

  }

  private canAccess(menu: SettingMenu): boolean {
    if (!menu.expectedRole) return true;
    const role = this.authService.user?.role;
    return role ? menu.expectedRole.includes(role) : false;
  }

  selectedMenuOnChange(menu: SettingMenu): void {
    this.menuSelected = menu;
  }

}
